<div class="company-addresses">
  <div class="company-addresses__header navigation__medium--m udex-mb-8">{{ header | cxTranslate }}</div>
  <div
    *ngIf="isCreateNewLocationFeatureToggleEnabled"
    class="company-addresses__button udex-mb-12 udex-mb-sm-8 udex-pt-12 udex-pt-sm-0"
  >
    <udex-button
    (click)="openModal()"
    size="Small"
    data-cy="add-new-location-btn"
    design="Secondary"
  >
    {{addAddressModalLinkText}}
  </udex-button>
  </div>
  <ng-container *ngIf="!isCreateNewLocationFeatureToggleEnabled && addresses?.length === 1">
    <div data-cy="single-address" class="company-addresses__address" [innerHTML]="addresses[0] | transformAddresses"></div>
  </ng-container>

  <ng-container *ngIf="addresses?.length >= 1; else noAddresses">
    <div
      *ngIf="isCreateNewLocationFeatureToggleEnabled || addresses?.length > 1"
      class="company-addresses__address"
      data-cy="multiple-addresses"
    >
      <ds-combo-box #comboBox (valueChange)="onAddressChange($event[0])" [multiline]="true"
                    [selectedHtml]='selectedAddressData'>
        <ds-combo-box-dropdown
          [initialValue]="[addresses[initialSelectedShipToAddress].sapAddressUUID || addresses[initialSelectedShipToAddress].externalAddressNumber || addresses[initialSelectedShipToAddress].id]"
          [showSearchBar]="false">
          <ds-combo-box-dropdown-group maxHeight="12.5rem">
            <ds-combo-box-dropdown-option #dropdownOptions
                                          *ngFor="let address of addresses"
                                          [isEditable]="addressesEditableFeatureToggle && showEditButton"
                                          [isEditDisabled]="!address.isEditable"
                                          [editButtonTooltip]="address.isEditable ? null : ('checkout.digitalNativeCheckout.editAddress.tooltip.disabled' | cxTranslate)"
                                          [value]="address.sapAddressUUID || address.externalAddressNumber || address.id"
                                          (editClick)="onEditClick(address)"
            >
              <span [innerHTML]="address | transformAddresses"></span>
            </ds-combo-box-dropdown-option>
          </ds-combo-box-dropdown-group>
        </ds-combo-box-dropdown>
      </ds-combo-box>
    </div>
  </ng-container>
  <ng-template #noAddresses>
    <div
      *ngIf="isCreateNewLocationFeatureToggleEnabled"
      class="d-flex align-items-center ds-disabled company-addresses__address form-control__wrapper"
      data-cy="zero-addresses"
    >
      <div class="flex-grow-1 py-4 px-2 user-select-none"></div>
      <em class="flex- ds-icon ds-icon--arrow-down ds-icon--big p-2"></em>
    </div>
  </ng-template>
</div>

<dcp-address-add-modal
  [openModal$]="openModal$"
  [addressUsage]="addAddressModalUsageType"
  [headerText]="addAddressModalHeaderText"
  [createButtonText]="actionButtonAlternativeText || addAddressModalCreateButtonText"
  (newAddressCreated)="addNewAddress($event); onAddressChange($event.sapAddressUUID || $event.externalAddressNumber || $event.id);"
>
</dcp-address-add-modal>
<dcp-address-add-modal
  [openModal$]="openEditModal$"
  [headerText]="editAddressModalHeaderText"
  [addressUsage]="addAddressModalUsageType"
  [createButtonText]="editAddressModalSubmitButtonText"
  [addressToEdit]="addressToEdit"
  (addressEdited)="updateAddress($event)"
>
</dcp-address-add-modal>
